import { faLandmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components';

const NodeContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: #E0F7FA;
  border: 1px solid #00ACC1;
  width: 200px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`;

const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const NodeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #00ACC1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 8px;
`;

const NodeLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #00ACC1;
  flex: 1;
`;

const NodeType = styled.div`
  font-size: 10px;
  background: rgba(26, 25, 43, 0.1);
  color: #1a192b;
  padding: 2px 6px;
  border-radius: 4px;
`;

const NodeDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
`;

const NodeDetails = styled.div`
  font-size: 11px;
  color: #777;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DetailItem = styled.div`
  display: flex;
`;

const DetailLabel = styled.span`
  font-weight: 500;
  margin-right: 5px;
`;

const DetailValue = styled.span`
  color: #555;
`;

const KnowledgeNode = ({ data }) => {
  // const { label, description, knowledgeType, source } = data;
  const {
    id= 'node-'+new Date().getTime(),
    name = 'KB',
    description = 'No description provided',
    type = 'Knowledgebase',
    tags = [],
    capabilities = [],
   source=''
  } = data;
  
  const knowledgeTypeLabels = {
    kb: 'Knowledge Base',
    data: 'Data Source',
    vector: 'Vector Store'
  };
  
  return (
    <NodeContainer>
      <Handle type="target" position={Position.Top} />
      
      <NodeHeader>
        <NodeIcon><FontAwesomeIcon icon={faLandmark} /></NodeIcon>
        <NodeLabel>{name}</NodeLabel>
        {/* <NodeType>{knowledgeTypeLabels[knowledgeType] || 'Knowledge'}</NodeType> */}
      </NodeHeader>
      
      <NodeDescription>{description}</NodeDescription>
      
      <NodeDetails>
        {source && (
          <DetailItem>
            <DetailLabel>Source:</DetailLabel>
            <DetailValue>{source}</DetailValue>
          </DetailItem>
        )}
      </NodeDetails>
      
      <Handle type="source" position={Position.Bottom} />
    </NodeContainer>
  );
};

export default memo(KnowledgeNode);
